import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../state/app.state';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { CommonService } from '../../services/common.service';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'app-global-ai-assistant',
  templateUrl: './global-ai-assistant.component.html',
  styleUrls: ['./global-ai-assistant.component.css']
})
export class GlobalAiAssistantComponent implements AfterViewInit {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  form = new FormGroup({
    question: new FormControl(null)
  });

  questions = [];
  sessionId = uuid();

  @ViewChild('chatHistory') private chatHistory: ElementRef;

  constructor(
    private store: Store<fromRoot.State>,
    private backendHandler: HttpBackend,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    this.sessionId = uuid();
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  askQuestion() {
    this.commonService.startLoading();

    const question = this.form.controls.question.value;

    this.form.controls.question.setValue(null);

    const http = new HttpClient(this.backendHandler);
    http.post(`https://schoolvoices360.app.n8n.cloud/webhook/989f5fb1-af16-4682-be22-dbe383fc02de/chat`, {
        action: 'sendMessage',
        chatInput: question,
        sessionId: this.sessionId,
      })
      .subscribe(
        (data) => {
          this.questions = [
            ...this.questions,
            {
              question: question,
              answer: data['output']
            }
          ];

          setTimeout(() => {
            this.scrollToBottom();
          }, 10);

          this.commonService.stopLoading();
        },
        (error) => {
          this.commonService.notification('Unable to fetch answer', 'danger');
          this.commonService.stopLoading();
        });
  }

  private scrollToBottom(): void {
    if (this.chatHistory) {
      try {
        this.chatHistory.nativeElement.scrollTop = this.chatHistory.nativeElement.scrollHeight;
      } catch(err) {
        console.error('Scroll to bottom failed', err);
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
